<template>
  <v-form>
    <v-card id="card-page-type">
      <v-container>
        <v-row class="nonothing">
          <v-col cols="4">
            <h3>Data de publicação:<b class="requiredfield">*</b></h3>
          </v-col>

          <v-col cols="8">
            <v-row>
              <v-col cols="8">
                <v-menu
                  v-model="pollData.menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedDateFormatted"
                      label="Informe a data"
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="pollData.date"
                    no-title
                    @input="pollData.menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="4">
                <v-text-field
                  pattern="^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$"
                  type="time"
                  prepend-icon="access_time"
                  v-model="pollData.publicationTime"
                  label
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-sheet v-show="publicationDateError" class="red--text">
              {{ publicationDateError }}
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card
      id="card-page-type"
      v-show="poll.data.pageType !== 'VOTING_SHOWCASE'"
    >
      <v-container>
        <v-row class="nonothing">
          <v-col cols="4">
            <h3>
              Prazo para votação dos projetos:<b class="requiredfield">*</b>
            </h3>

            <v-sheet class="red--text" v-if="invalidRangeDate">
              {{ invalidRangeDateText }}
            </v-sheet>

            <v-sheet class="red--text" v-if="requiredErrorTime">
              {{ requiredErrorTimeText }}
            </v-sheet>
          </v-col>

          <v-col cols="8">
            <v-row>
              <v-col cols="3">
                <v-menu
                  v-model="pollData.menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedDateFormattedStart"
                      label="Informe a data"
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="pollData.dateStart"
                    no-title
                    @input="pollData.menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  pattern="^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$"
                  type="time"
                  prepend-icon="access_time"
                  v-model="pollData.deadlineTimeStart"
                  label
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="3">
                <v-menu
                  v-model="pollData.menu3"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedDateFormattedEnd"
                      label="Informe a data"
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="pollData.dateEnd"
                    no-title
                    @input="pollData.menu3 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  pattern="^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$"
                  type="time"
                  prepend-icon="access_time"
                  v-model="pollData.deadlineTimeEnd"
                  label
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card id="card-page-type">
      <v-container>
        <v-row class="nonothing">
          <v-col cols="4">
            <h3>Link personalizado:<b class="requiredfield">*</b></h3>

            <v-sheet class="red--text" v-if="requiredErrorLink">
              {{ requiredErrorLinkText }}
            </v-sheet>

            <v-sheet class="red--text" v-if="specialErrorLink">
              {{ specialErrorLinkText }}
            </v-sheet>
          </v-col>

          <v-col cols="8">
            <v-text-field
              v-model="customLink"
              label="Insira o link desejado para sua whitelabel. Ex.: minhavotacao.prosas.com.br"
              required
            ></v-text-field>
            <v-sheet class="ma-0 pa-0" v-show="customLink"
              >{{ customLink }}.prosas.com.br</v-sheet
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card id="card-page-type">
      <v-container>
        <v-row class="nonothing">
          <v-col cols="4">
            <h3>
              Selecione os dados que serão mostrados na página do projeto:
              <b class="requiredfield">*</b>
            </h3>
          </v-col>

        </v-row>
        <v-row>
          <v-col cols="6">
            <v-treeview
              selectable
              open-all
              v-model="itemsSelecetedProjectData"
              :items="itemsProjectData"
              class="preline"
            ></v-treeview>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card
      id="card-page-type"
      v-show="poll.data.pageType !== 'VOTING_SHOWCASE'"
    >
      <v-container>
        <v-row class="nonothing">
          <v-col cols="4">
            <h3>Privacidade da pontuação:</h3>
          </v-col>

          <v-col cols="8">
            <v-switch
              v-model="pollData.privacy"
              label="Desejo que a pontuação de cada projeto seja privada."
            ></v-switch>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card
      id="card-page-type"
      v-show="poll.data.pageType !== 'VOTING_SHOWCASE'"
    >
      <v-container>
        <v-row class="nonothing">
          <v-col cols="4">
            <h3>Quantidade de votos:</h3>
          </v-col>

          <v-col cols="8">
            <v-switch
              v-model="pollData.quantityOfVotes"
              label="Desejo inserir um limite de votos por e-mail."
            ></v-switch>
            <v-text-field
              type="number"
              v-show="pollData.quantityOfVotes"
              v-model="voteLimitPerEmail"
              label="Limite de votos por email"
            ></v-text-field>
            <v-sheet
              v-show="voteLimitPerEmailError"
              v-bind="voteLimitPerEmailError"
              class="red--text"
              >{{ voteLimitPerEmailError }}
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card
      id="card-page-type"
      v-show="poll.data.pageType !== 'VOTING_SHOWCASE'"
    >
      <v-container>
        <v-row class="nonothing">
          <v-col cols="4">
            <h3>Restrição de votos por e-mail:</h3>
          </v-col>

          <v-col cols="8">
            <v-switch
              v-model="pollData.emailRestriction"
              label="Desejo determinar os domínios que poderão votar."
            ></v-switch>

            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>

            <span
              class="group pa-2"
              v-for="(input, indx) in pollData.email"
              :key="indx"
            >
              <v-text-field
                v-model="input.name"
                label="Insira as extensões de e-mail para restrição"
                hint="Não é necessário a inclusão do @ (Ex. correto: prosas.com.br)"
                persistent-hint
                required
                @keydown="validacaoEmail($event)"
              ></v-text-field>

              <v-icon
                color="error"
                @click="remove(indx)"
                v-show="indx || (!indx && pollData.email.length > 1)"
                >remove</v-icon
              >
              <v-icon
                color="primary"
                @click="add(indx)"
                v-if="pollData.email[pollData.email.length - 1].name !== ''"
                v-show="indx == pollData.email.length - 1"
                >add</v-icon
              >
            </span>
            <v-sheet
              v-show="emailRestrictionError"
              v-bind="emailRestrictionError"
              class="red--text"
              >{{ emailRestrictionError }}
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-form>
</template>


<script>
import moment from "moment";
import i18n from "@/i18n";

export default {
  props: ["poll"],
  data: (vm) => ({
    formData: {},
    projectDatas: [
      // EMPREENDEDOR
      {
        name: i18n.t("entrepreneurName"),
        id: "entrepreneurName",
        group: "empreendedor",
        selected: true,
      },
      {
        name: i18n.t("entrepreneurAbout"),
        id: "entrepreneurAbout",
        group: "empreendedor",
        selected: true,
      },
      {
        name: i18n.t("entrepreneurFoundedOn"),
        id: "entrepreneurFoundedOn",
        group: "empreendedor",
        selected: false,
      },
      {
        name: i18n.t("entrepreneurType"),
        id: "entrepreneurType",
        group: "empreendedor",
        selected: false,
      },

      // ṔROPOSTA
      {
        name: i18n.t("nameOfProject"),
        id: "nameOfProject",
        group: "proposta",
        selected: true,
      },
      {
        name: i18n.t("description"),
        id: "description",
        group: "proposta",
        selected: true,
      },
      {
        name: i18n.t("actingLocations"),
        id: "actingLocations",
        group: "proposta",
        selected: false,
      },
      {
        name: i18n.t("ods"),
        id: "ods",
        group: "proposta",
        selected: false
      },
      {
        name: i18n.t("sites"),
        id: "sites",
        group: "proposta",
        selected: false,
      },
      {
        name: i18n.t("areasOfInterest"),
        id: "areasOfInterest",
        group: "proposta",
        selected: false,
      },
      {
        name: i18n.t("complementaryFiles"),
        id: "complementaryFiles",
        group: "proposta",
        selected: false,
      },
      {
        name: i18n.t("subareasOfInterest"),
        id: "subareasOfInterest",
        group: "proposta",
        selected: false,
      },
      {
        name: i18n.t("targetsAudience"),
        id: "targetsAudience",
        group: "proposta",
        selected: false,
      },
      {
        name: i18n.t("fundingSource"),
        id: "fundingSource",
        group: "proposta",
        selected: false,
      },
      {
        name: i18n.t("movies"),
        id: "movies",
        group: "proposta",
        selected: false,
      },
      {
        name: i18n.t("projectStatus"),
        id: "projectStatus",
        group: "proposta",
        selected: false,
      },
      {
        name: i18n.t("idwall_status"),
        id: "idwall_status",
        group: "proposta",
        selected: false,
      },
      {
        name: i18n.t("proposedValue"),
        id: "proposedValue",
        group: "proposta",
        selected: false,
      },
      {
        name: i18n.t("approvedValue"),
        id: "approvedValue",
        group: "proposta",
        selected: false,
      },
      {
        name: i18n.t("socialNetwork"),
        id: "socialNetwork",
        group: "proposta",
        selected: false,
      },

      // AVALIAÇÃO
      {
        name: i18n.t("evaluation"),
        id: "evaluation",
        group: "avaliacao",
        selected: false,
      },
    ],
    questionsData: [],
    itemsProjectData: [],
    itemsSelecetedProjectData: [],
    pollData: {
      menu1: false,
      menu2: false,
      menu3: false,

      date: new Date().toISOString().substr(0, 10),
      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),

      dateStart: new Date().toISOString().substr(0, 10),
      dateFormattedStart: vm.formatDate(new Date().toISOString().substr(0, 10)),

      dateEnd: new Date().toISOString().substr(0, 10),
      dateFormattedEnd: vm.formatDate(new Date().toISOString().substr(0, 10)),

      publicationTime: "00:00",
      deadlineTimeStart: "00:00",
      deadlineTimeEnd: "00:00",

      link: "",

      selected: "",

      quantityOfVotes: true,
      privacy: false,
      emailRestriction: true,

      timeMask: "/^[a-z][0-9]+(-[a-z][0-9]+)*$/",

      email: [{ name: "" }],
    },
    // Form validation auxiliars
    itemsWithErrors: {
      publicationDateTime: false,
      dateStartAndDateEnd: false,
      customLink: false,
      projectDataForDisplay: false,
      privacy: false,
      voteLimitPerEmail: false,
      votingRestrictionByEmail: false,
      requiredTime: false,
    },
    publicationDateError: undefined,
    requiredErrorLink: false,
    invalidRangeDate: false,
    specialErrorLink: false,
    requiredErrorTime: false,
    requiredErrorLinkText: "",
    invalidRangeDateText: "",
    specialErrorLinkText: "",
    requiredErrorTimeText: "",
    voteLimitPerEmailError: null,
    emailRestrictionError: null,
    // END Form validation auxiliars
    pollLoaded: false, // Controls loading data from backend
  }),

  computed: {
    publicationDate: {
      get() {
        return this.$store.state.poll.configuration.publicationDate;
      },
      set(value) {
        this.$store.commit("updatePublicationDate", value);
      },
    },
    deadlineForVotingOnProjectsFrom: {
      get() {
        return this.$store.state.poll.configuration.deadlineForVotingOnProjects
          .from;
      },
      set(value) {
        this.$store.commit("updateDeadlineForVotingOnProjectsFrom", value);
      },
    },
    deadlineForVotingOnProjectsTo: {
      get() {
        return this.$store.state.poll.configuration.deadlineForVotingOnProjects
          .to;
      },
      set(value) {
        this.$store.commit("updateDeadlineForVotingOnProjectsTo", value);
      },
    },
    customLink: {
      get() {
        return this.$store.state.poll.configuration.customLink;
      },
      set(value) {
        this.$store.commit("updateCustomLink", value);
      },
    },
    scoreAsPrivate: {
      get() {
        return this.$store.state.poll.configuration.scoreAsPrivate;
      },
      set(value) {
        this.$store.commit("updateScoreAsPrivate", value);
      },
    },
    voteLimitPerEmail: {
      get() {
        return this.$store.state.poll.configuration.voteLimitPerEmail;
      },
      set(value) {
        this.$store.commit("updateVoteLimitPerEmail", value);
      },
    },
    votingRestrictionByEmail: {
      get() {
        return this.$store.state.poll.configuration.votingRestrictionByEmail;
      },
      set(value) {
        this.$store.commit("updateVotingRestrictionByEmail", value);
      },
    },
    computedDateFormatted() {
      return this.formatDate(this.pollData.date);
    },
    computedDateFormattedStart() {
      return this.formatDate(this.pollData.dateStart);
    },
    computedDateFormattedEnd() {
      return this.formatDate(this.pollData.dateEnd);
    },
  },

  methods: {
    validacaoEmail(e) {
      if (/(@)+/.test(e.key)) {
        e.preventDefault();
      }
    },
    setPollData() {
      // SENDING TO BACK
      this.publicationDate =
        this.pollData.date + "T" + this.pollData.publicationTime + ":00-03:00";
      this.deadlineForVotingOnProjectsFrom =
        this.pollData.dateStart +
        "T" +
        this.pollData.deadlineTimeStart +
        ":00-03:00";
      this.deadlineForVotingOnProjectsTo =
        this.pollData.dateEnd +
        "T" +
        this.pollData.deadlineTimeEnd +
        ":00-03:00";
      this.scoreAsPrivate = this.pollData.privacy;

      if (!this.pollData.quantityOfVotes) this.voteLimitPerEmail = null;

      // TODO: To fix, should not have a empty default email
      const emailsNames = this.pollData.email
        .map((email) => (email.name ? email.name : null))
        .filter((email) => email !== null);
      const emails = [...new Set(emailsNames)];
      if (this.pollData.emailRestriction === true || emails.length > 0) {
        this.votingRestrictionByEmail = emails;
      } else {
        this.votingRestrictionByEmail = null;
      }

      //Set all to false
      this.$store.commit("clearProjectDataForDisplay", {});

      // Set to true those are selected boolean
      this.itemsSelecetedProjectData.forEach((item) => {
        let found = this.projectDatas.find((i) => i.id == item);
        if (found) {
          this.$store.commit("updateProjectDataForDisplay", {
            attrName: found.id,
            attrValue: true,
          });
          return;
        }

        found = this.questionsData.find((i) => i.id == item);
        if (found) {
          this.$store.commit("updateProjectDataForDisplay", {
            attrName: "questions",
            attrValue: found.id,
          });
        }
      });
    },
    loadItemsProjectData() {
      this.questionsData = (this.$store.state.pollOpportunityQuestions || [])
        .sort((a, b) => a.order - b.order)
        .map((q) => ({ name: q.question, id: q.id, selected: false }));
      this.itemsProjectData = [
        {
          id: 'informacaoEmpreendedor',
          name: "Informações do Empreendedor",
          children: this.projectDatas.filter((q) => q.group == "empreendedor"),
        },
        {
          id: 'informacaoProposta',
          name: "Informações da proposta",
          children: [
            ...this.projectDatas.filter((q) => q.group == "proposta"),
            {
              id: 'perguntaFormulario',
              name: "Perguntas do formulário",
              children: [...this.questionsData],
            },
          ],
        },
        this.projectDatas.find((q) => q.group == "avaliacao"),
      ];
    },
    setFormData() {
      // GETTING FROM BACK

      if (this.pollLoaded || !this.poll.id) return;
      this.loadItemsProjectData();

      this.pollLoaded = true;
      // TODO: Change all dates to use moment
      if (this.publicationDate) {
        const publicationDateTime = this.publicationDate.split("T");
        this.pollData.date = publicationDateTime[0];
        if (publicationDateTime.length > 1) {
          this.pollData.publicationTime = publicationDateTime[1].substring(
            0,
            5
          );
        }
      }

      if (this.deadlineForVotingOnProjectsFrom) {
        const deadlineFromDateTime =
          this.deadlineForVotingOnProjectsFrom.split("T");
        this.pollData.dateStart = deadlineFromDateTime[0];
        if (deadlineFromDateTime.length > 1) {
          this.pollData.deadlineTimeStart = deadlineFromDateTime[1].substring(
            0,
            5
          );
        }
      }

      if (this.deadlineForVotingOnProjectsTo) {
        const deadlineToDateTime =
          this.deadlineForVotingOnProjectsTo.split("T");
        this.pollData.dateEnd = deadlineToDateTime[0];
        if (deadlineToDateTime.length > 1) {
          this.pollData.deadlineTimeEnd = deadlineToDateTime[1].substring(0, 5);
        }
      }

      this.pollData.customLink = this.customLink;
      this.pollData.privacy = this.scoreAsPrivate ? this.scoreAsPrivate : false;
      this.pollData.quantityOfVotes = this.voteLimitPerEmail ? true : false;

      if (!this.votingRestrictionByEmail) {
        this.pollData.emailRestriction = false;
      } else if (this.votingRestrictionByEmail.length === 0) {
        this.pollData.emailRestriction = false;
      } else {
        this.pollData.emailRestriction = true;
        this.pollData.email = [];
        this.votingRestrictionByEmail.map((email) =>
          this.pollData.email.push({ name: email })
        );
      }

      const pollDataForDisplay = this.poll.configuration.projectDataForDisplay;
      let itemsSelecetedProjectData = [];
      const satProjectDatas = this.projectDatas.map((item) => {
        const newItem = item;
        if (pollDataForDisplay[item.id]) {
          newItem.selected = true;
          itemsSelecetedProjectData.push(item.id);
        } else {
          newItem.selected = false;
        }
        return newItem;
      });
      this.projectDatas = satProjectDatas;

      const questionsSelection = pollDataForDisplay.questions || [];
      questionsSelection.forEach((id) => {
        const found = this.questionsData.find((q) => q.id == id);
        if (found) {
          found.selected = true;
          itemsSelecetedProjectData.push(found.id);
        }
      });
      this.itemsSelecetedProjectData = itemsSelecetedProjectData;
    },
    isFormValid() {
      this.hasErrors = false;
      this.validateFormConfig();
      this.hasErrors =
        !Object.values(this.itemsWithErrors).filter((error) => error).length >
        0;
      return this.hasErrors;
    },
    validateFormConfig() {
      this.requiredLink();
      this.linkHasSpecialCharacters();
      this.validateRangeDate();
      this.validateVoteLimitPerEmail();
      this.validateEmailRestriction();
      this.requiredTime();
    },
    requiredLink() {
      if (!this.customLink || this.customLink.trim() === "") {
        this.requiredErrorLink = true;
        this.itemsWithErrors.customLink = true;
        this.requiredErrorLinkText =
          "O campo link personalizado é obrigatório!";
      } else {
        this.requiredErrorLink = false;
        this.itemsWithErrors.customLink = false;
      }
    },
    validateVoteLimitPerEmail() {
      this.voteLimitPerEmailError = null;
      this.itemsWithErrors.voteLimitPerEmail = false;

      if (
        !this.pollData.quantityOfVotes ||
        this.poll.data.pageType !== "VOTING_PORTAL"
      )
        return; // pol voteLimitPerEmail attr is gonna be set to null
      if (this.voteLimitPerEmail > 0) return;

      this.itemsWithErrors.voteLimitPerEmail = true;
      this.voteLimitPerEmailError = "Informe um limite de votos válido";
    },
    validateEmailRestriction() {
      if (
        this.poll.data.pageType === "VOTING_SHOWCASE" ||
        !this.switchResctrictEmail ||
        this.pollData.email[0].name
      ) {
        if (this.poll.data.pageType === "VOTING_SHOWCASE") {
          this.switchResctrictEmail = false;
        }
        this.emailRestrictionError = null;
        this.itemsWithErrors.votingRestrictionByEmail = false;
        return;
      }
      this.itemsWithErrors.votingRestrictionByEmail = false;
      this.emailRestrictionError =
        "Ao menos um domínio de email deve ser informado para restrição";
    },
    linkHasSpecialCharacters() {
      if (this.customLink) {
        var chars_regex = /[^\w\s]/g;
        var blank_regex = /\s/g;
        if (
          chars_regex.test(this.customLink) ||
          blank_regex.test(this.customLink)
        ) {
          this.specialErrorLink = true;
          this.itemsWithErrors.customLink = true;
          this.specialErrorLinkText =
            "O campo link personalizado não pode conter caracteres especiais ou espaço em branco!";
        } else {
          this.specialErrorLink = false;
          this.itemsWithErrors.customLink = false;
        }
      }
    },
    validateRangeDate() {
      this.invalidRangeDateText = null;
      this.publicationDateError = null;
      this.invalidRangeDate = false;
      this.itemsWithErrors.dateStartAndDateEnd = false;

      if (!this.pollData.date || !this.pollData.publicationTime) {
        this.publicationDateError = "Informe a data de publicação!";
      } else if (!this.pollData.dateStart || !this.pollData.deadlineTimeStart) {
        this.invalidRangeDateText = "Informe a data de inicio!";
      } else if (!this.pollData.dateEnd || !this.pollData.deadlineTimeEnd) {
        this.invalidRangeDateText = "Informe a data de término!";
      }
      if (this.invalidRangeDateText || this.publicationDateError) {
        this.invalidRangeDate = true;
        this.itemsWithErrors.dateStartAndDateEnd = true;
        return;
      }

      const publishDate = new moment(
        this.pollData.date + "T" + this.pollData.publicationTime + ":00-03:00"
      );
      const voteIntervalFrom = new moment(
        this.pollData.dateStart +
          "T" +
          this.pollData.deadlineTimeStart +
          ":00-03:00"
      );
      const voteIntervalTo = new moment(
        this.pollData.dateEnd +
          "T" +
          this.pollData.deadlineTimeEnd +
          ":00-03:00"
      );

      if (voteIntervalFrom.isBefore(publishDate)) {
        this.invalidRangeDateText =
          "O periodo de votação não pode ser antes da data de publicação!";
      } else if (voteIntervalTo.isBefore(voteIntervalFrom)) {
        this.invalidRangeDateText =
          "A data final nao pode ser antes da data inicial!";
      }

      if (this.invalidRangeDateText || this.publicationDateError) {
        this.invalidRangeDate = true;
        this.itemsWithErrors.dateStartAndDateEnd = true;
      }
    },
    requiredTime() {
      if (
        !this.pollData.publicationTime ||
        !this.pollData.deadlineTimeStart ||
        !this.pollData.deadlineTimeEnd
      ) {
        this.requiredErrorTime = true;
        this.itemsWithErrors.requiredTime = true;
        this.requiredErrorTimeText =
          "Os campos de data e prazo precisam ter as horas especificadas!";
        return;
      }
      this.itemsWithErrors.requiredTime = false;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },

    add(index) {
      this.pollData.email.push({ name: "" });
    },
    remove(index) {
      this.pollData.email.splice(index, 1);
    },
  },
};
</script>

<style>
  .v-treeview-node__root {
    align-items: end;
    margin: 0 0 10px;
  }

  .v-treeview-node__label {
    white-space: pre-line;
    unicode-bidi: embed;
  }
</style>

<style lang="scss" scoped>
  .nonothing {
    margin: 0 !important;
    padding: 0 !important;
  }

  // FORMSPAGE
  #card-page-type {
    background: #fcfcfc !important;
    border: thin solid #d3d3d3;
    border-left: 3px solid #2d9fab;
    box-shadow: none !important;
    margin: 0 0 24px !important;
    padding: 8px !important;
    display: grid;
    border-radius: 0 !important;

    h3 {
      color: #242424;
      font-family: "Source Sans Pro", sans-serif;
      margin: 0 0 10px;
      font-size: 18px;
      line-height: 22px;
      font-weight: normal;
      opacity: 0.9;

      .requiredfield {
        color: #2e9fac;
        font-size: 22px;
        line-height: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/poll/FormPollConfig.vue